export const dataDeviceData = {
  type: 'object',
  required: ['DeviceId', 'DeviceModel', 'DeviceSerial', 'DeviceAllocatedId'],
  properties: {
    DeviceId: {
      type: 'string',
      minLength: 1,
    },
    DeviceModel: {
      type: 'string',
      minLength: 1,
    },
    StudentVersion: {
      type: ['null', 'string'],
    },
    DeviceSerial: {
      type: 'string',
      minLength: 1,
    },
    DeviceAllocatedId: {
      type: 'string',
      minLength: 1,
    },
  },
};
